const steps = [
  { num: '01', title: 'Creazione account', desc: 'Il primo passo &egrave; creare il tuo account su Itaobuy Spreadsheet. Il processo &egrave; rapido e richiede solo pochi minuti.' },
  { num: '02', title: 'Configurazione iniziale', desc: 'Personalizza il tuo spazio di lavoro in base alle tue esigenze specifiche e importa i dati esistenti.' },
  { num: '03', title: 'Gestione spreadsheet', desc: 'Inizia a utilizzare tutte le funzionalit&agrave; per organizzare, filtrare e analizzare i tuoi dati.' },
  { num: '04', title: 'Ottimizzazione utilizzo', desc: 'Scopri funzionalit&agrave; avanzate e automatizza i processi per massimizzare la tua produttivit&agrave;.' },
];

export default function HowItWorksSection() {
  return (
    <section className="w-full py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            Come funziona <strong>Itaobuy Spreadsheet</strong>?
          </h2>
          <p className="text-base text-foreground-600 max-w-2xl mx-auto">
            Segui questi quattro semplici passi per iniziare a utilizzare Itaobuy Spreadsheet.
          </p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-12 left-[12.5%] right-[12.5%] h-0.5 bg-primary-200"></div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {steps.map((step) => (
              <div key={step.num} className="relative text-center group">
                <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-xl font-bold font-heading group-hover:bg-primary-600 transition-colors relative z-10">
                  {step.num}
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">{step.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}